// @flow
import ReactPiwik from "react-piwik";
import BaseTracker from "./BaseTracker";
import type {Product} from "../../models/Product";
import type {OrderReducerState} from "../../reducers/orderReducer";
import type {CouponReducerState} from "../../reducers/couponReducer";

export default class PiwikTracker extends BaseTracker {
	constructor(trackingId: string, trackingHostUrl: string, withEcommerce: boolean = false) {
		super(trackingId, withEcommerce);
		this.tracker = new ReactPiwik({
			siteId: this.trackingId,
			jsFilename: this.trackingId + ".js",
			url: trackingHostUrl
		});
	}

	logOrder(order: OrderReducerState, coupon: ?CouponReducerState = null) {
		ReactPiwik.push(["trackEcommerceOrder", order.order.orderNo, order.totalBillingAmount.cost]);
	}

	addItem(product: Product, amount: number = 1) {
		ReactPiwik.push(["addEcommerceItem", product.articleNumber, product.name, null, product.price.value, amount]);
	}

	removeItem(product: Product, amount: number) {
		ReactPiwik.push(["removeEcommerceItem", product.articleNumber]);
	}

	clearCart() {
		ReactPiwik.push(["clearEcommerceCart"]);
	}
}
